var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "400px",
    width: "400px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1,-1) translate(-5,-950)",
    d: "M525 226q-26 0-45-19t-19-45q0-25 19-44.5t45-19.5q25 0 44.5 19.5t19.5 44.5q0 26-19.5 45t-44.5 19zM525 141q-10 0-16 6t-6 15q0 10 6 15.5t16 5.5q9 0 15-5.5t6-15.5q0-9-6-15t-15-6zM516 777q-35 0-69-13t-63-39q-26-25-40.5-58.5t-14.5-69.5q0-9 7-15t14-6q6 0 13.5 6t7.5 15q0 29 10 54t33 44q19 20 45.5 29.5t52.5 9.5q54 0 93-41.5t39-99.5q0-29-12-56t-35-46l-76-77q-13-13-21.5-31.5t-8.5-41.5v-51q0-9 5.5-15t15.5-6 15.5 6 5.5 15v51q0 13 4 23t13 20l77 77q29 25 44.5 59.5t15.5 72.5q3 74-47 127t-124 57v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.70525770a037a90deaee0ca1ba4b50be.svg";
export { ForwardRef as ReactComponent };